const removeLineBreaks = (input: string): string => {
  return input.replace(/^\s+|\s+$/g, '');
};

export default removeLineBreaks;
